import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { GoldButton, GhostButton } from "@/components/site/ui";
import { useLead } from "@/context/LeadContext";

export function FinalCTA() {
    const nav = useNavigate();
    const { openLead } = useLead();
    return (
        <section className="bg-gradient-to-br from-teal-800 to-teal-950 py-24 grain relative overflow-hidden" data-testid="final-cta">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-gold/10 blur-3xl" />
            <div className="container-x relative text-center max-w-3xl mx-auto">
                <h2 className="font-serif text-4xl sm:text-5xl leading-tight text-cream">Ready to Take Your Business Online?</h2>
                <p className="mt-5 text-lg text-cream-soft">Start with one service or build a complete digital growth package for your business.</p>
                <div className="mt-8 flex flex-wrap justify-center gap-4">
                    <GoldButton onClick={() => nav("/services")} className="!px-8 !py-4 text-base" data-testid="final-get-started">Get Started From ₹199 <ArrowRight className="w-4 h-4" /></GoldButton>
                    <GhostButton onClick={() => openLead()} className="!px-8 !py-4 text-base" data-testid="final-talk-expert">Talk to a Growth Expert</GhostButton>
                </div>
            </div>
        </section>
    );
}
